const BOT_UA_PATTERNS = [
  'googlebot',
  'bingbot',
  'duckduckbot',
  'baiduspider',
  'yandexbot',
  'applebot',
  'gptbot',
  'claudebot',
  'ccbot',
  'anthropic-ai',
  'perplexitybot',
  'perplexity-bot',
  'google-extended',
  'facebookexternalhit',
  'twitterbot',
  'linkedinbot',
  'slackbot',
  'telegrambot',
  'whatsapp',
  'discordbot',
];

export function isBotUserAgent(userAgent: string | null | undefined): boolean {
  if (!userAgent) {
    return false;
  }
  const lower = userAgent.toLowerCase();
  return BOT_UA_PATTERNS.some((pattern) => lower.includes(pattern));
}
